import React from 'react';
import { Link } from 'react-router-dom';

const ServiceUnavailablePage = () => {
  return (
    <div className="error-page">
      <h1>503 Service Unavailable</h1>
      <p>The server is currently unable to handle the request. Please try again later.</p>
      <Link to="/">Go back to Home</Link>
    </div>
  );
};

export default ServiceUnavailablePage;
